import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// modules
import auth from './modules/auth';
import widgets from './modules/widgets';
import settings from './modules/settings';
// import ecommerce from './modules/ecommerce';
import sidebar from './modules/sidebar';
import user from './modules/user';
// import social from './modules/social';
// import mail from './modules/mail';
// import dataset from './modules/dataset';

// widgets [market/]
import accommodations from './component/market/accommodations';
import competitors from './component/market/competitors';
import event from './component/market/event';
import statistic from './component/market/informations/statistic';
import forcast from './component/market/informations/forcast';
import outbound from './component/market/outbound';
import population from './component/market/population';
import service from './component/market/service';
import transport from './component/market/transport';
import vos from './component/market/vos';

// widgets [tourist/]
import campaign from './component/tourist/campaign';
import contacts from './component/tourist/contacts';
import gdp from './component/tourist/gdp';
import table from './component/tourist/gdp/table';
import length_of_stay from './component/tourist/length_of_stay';
import media from './component/tourist/media';
import prospect from './component/tourist/prospect';
import spending from './component/tourist/spending';
import voc from './component/tourist/voc';
import vocPub from './component/tourist/voc_public';

import cdds from './component/cdds';
import caats from './component/caats';
import access from './component/access';
import tatics from './component/tatics';
import surveys from './component/surveys';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    widgets,
    user,
    settings,
    sidebar,
    accommodations,
    competitors,
    event,
    statistic,
    forcast,
    outbound,
    population,
    service,
    transport,
    vos,
    campaign,
    contacts,
    gdp,
    table,
    length_of_stay,
    media,
    prospect,
    spending,
    voc,
    vocPub,
    cdds,
    caats,
    access,
    tatics: tatics,
    surveys: surveys
  },
  plugins: [
    createPersistedState({
      key: 'site',
      paths: ['auth'],
      filter: (mutation) => mutation.type == 'SET_USER' || mutation.type == 'SET_PERMISSION'
    })
  ]
})